// Checking for idleness becomes a no-op when IDLE_WARN_AFTER_SECONDS is set to "", either by explicitly setting it to
// "" in the properties file, or by not defining the idleWarnAfterSeconds element.
var IDLE_WARN_AFTER_SECONDS = document.getElementById("idleWarnAfterSeconds")
  ? document.getElementById("idleWarnAfterSeconds").value : "";
var IDLE_WARN_DURATION_SECONDS = document.getElementById("idleWarnDurationSeconds")
  ? document.getElementById("idleWarnDurationSeconds").value : "300";
var IDLE_CHECK_INTERVAL_SECONDS = document.getElementById("idleTimeCheckIntervalSeconds")
  ? document.getElementById("idleTimeCheckIntervalSeconds").value : "60";
var EXCLUDED_MOBILE_AGENTS = document.getElementById("idleExcludedMobileAgents")
  ? document.getElementById("idleExcludedMobileAgents").value : "WQA";
var TIMEOUT_CHECK_INVERVAL = IDLE_CHECK_INTERVAL_SECONDS * 1000;
var _startIdleTime = Date.now();
var _expireTimestamp = null;
var pluralMinuteTimeMsg = localText["text.timeout.timeMarker.plural.minute"];
var singleMinuteTimeMsg = localText["text.timeout.timeMarker.single.minute"];
var pluralSecondTimeMsg = localText["text.timeout.timeMarker.plural.second"];
var singleSecondTimeMsg = localText["text.timeout.timeMarker.single.second"];

var allowTimestampReset = true;
var idleTimeCheckInterval = null;

function resetTimestamps(eventName) {
  if(IDLE_WARN_AFTER_SECONDS != "" && allowTimestampReset) {
    _startIdleTime = Date.now();
    _expireTimestamp = _startIdleTime + (IDLE_WARN_AFTER_SECONDS * 1000) + (IDLE_WARN_DURATION_SECONDS * 1000);
    clearInterval(idleTimeCheckInterval);
    startTimeCheck();
  }
}

document.onclick = function () {
  resetTimestamps("onclick");
};
document.onmousemove = function () {
  resetTimestamps("onmousemove");
};
document.onkeypress = function () {
  resetTimestamps("onkeypress");
};
// ontouch and onscroll were added for mobile support.
document.ontouch = function () {
  resetTimestamps("ontouch");
};
document.onscroll = function () {
  resetTimestamps("onscroll");
};

function isInEnrollmentFlow() {
  if(typeof dotUserId !== 'undefined') {
    // Is dotUserId a 36 character v4 UUID?
    let uuidRegex = /^[a-z,0-9,-]{36,36}$/
    if(uuidRegex.test(dotUserId)) {
      return true;
    }
  }
  return false;
}

function isAnonymous() {
  if(typeof dotUserId !== 'undefined') {
    // isAnonymousUser and IS_ANONYMOUS_USER are not consistent. dotUserId is consistent.
    if(dotUserId === 'anonymous') {
      return true;
    }
  }
  return false;
}

function isMobileAgent() {
  const excludedMobileAgents = EXCLUDED_MOBILE_AGENTS.split(",");
  for(const excludedAgent of excludedMobileAgents) {
    const lowerExcludedAgent = excludedAgent.toLowerCase();
    const lowerUserAgent = navigator.userAgent.toLowerCase();
    if(lowerUserAgent.includes(lowerExcludedAgent)) {
      return true;
    }
  }
  return false;
}

function enforceIdleTimeout() {
  if(!isMobileAgent() && IDLE_WARN_AFTER_SECONDS != "" && !isAnonymous()) {
    return true;
  }
  return false;
}

if(IDLE_WARN_AFTER_SECONDS != "") {
  idleTimeCheckInterval = window.setInterval(checkIdleTime, TIMEOUT_CHECK_INVERVAL);
}

function startTimeCheck() {
  if(IDLE_WARN_AFTER_SECONDS != "") {
    idleTimeCheckInterval = window.setInterval(checkIdleTime, TIMEOUT_CHECK_INVERVAL);
  }
}

function checkIdleTime() {
  if(enforceIdleTimeout()) {
    if(_expireTimestamp == null) {
      _expireTimestamp = _startIdleTime + (IDLE_WARN_AFTER_SECONDS * 1000) + (IDLE_WARN_DURATION_SECONDS * 1000);
    }
    var _elapsedTimeSeconds = Math.floor((Date.now() - _startIdleTime) / 1000);

    if(_elapsedTimeSeconds >= IDLE_WARN_AFTER_SECONDS) {
      clearInterval(idleTimeCheckInterval);
      showIdleMessage();
    }
  }
}

function getDuration() {
  var totalSeconds = parseInt(IDLE_WARN_AFTER_SECONDS) + parseInt(IDLE_WARN_DURATION_SECONDS);
  var durationMinutes = Math.floor(totalSeconds / 60);
  var durationSeconds = Math.floor(totalSeconds % 60);

  var duration = "";
  switch(durationMinutes) {
    case 0:
      break;
    case 1:
      duration += `${durationMinutes} ${singleMinuteTimeMsg}`;
      break;
    default:
      duration += `${durationMinutes} ${pluralMinuteTimeMsg}`;
  }
  switch(durationSeconds) {
    case 0:
      break;
    case 1:
      duration += `${durationSeconds} ${singleSecondTimeMsg}`;
      break;
    default:
      duration += `${durationSeconds} ${pluralSecondTimeMsg}`;
  }
  return duration;
}

const postTimeout = async () => {
  try {
    const response = await fetch(contextPath + "/timeout", {
      method: 'POST',
      headers: {
        Accept: "application/json"
      }
    });
    if(!response.ok) {
      throw new Error("Failed to log session timeout. Response code: " + response.status + " text: "
                        + response.statusText);
    }
  } catch(exception) {
    return exception.message;
  }
  return "Successfully logged session timeout.";
}


function showIdleMessage() {
  var _showIdleMessageExpireTimestamp = _expireTimestamp;
  var warningSecondsLeft = IDLE_WARN_DURATION_SECONDS;
  var minutesLeft = Math.floor(warningSecondsLeft / 60);
  var secondsLeft = Math.floor(warningSecondsLeft % 60);
  var date = new Date(new Date().getTime() + (minutesLeft * 60000) + (secondsLeft * 1000));
  var time = formatTime(date);
  var idleModal = null;

  var bodyText = localText["text.timeout.body"].replace("{0}", getDuration());
  var message = "<p>" + bodyText + "<br><br>" + localText["text.timeout.timeLeft"];

  message += " <strong><span id='sessionTimeMinutesLeft' style='display: none;'>" + minutesLeft + "</span></strong> " +
    "<strong><span id='timeMinuteMarker' style='display: none;'>" + (minutesLeft == 1 ? singleMinuteTimeMsg : pluralMinuteTimeMsg) +
    "</span></strong>";
  message += " <strong><span id='sessionTimeSecondsLeft' style='display: none;'>" + secondsLeft + "</span></strong> " +
    "<strong><span id='timeSecondMarker' style='display: none;'>" + (secondsLeft == 1 ? singleSecondTimeMsg : pluralSecondTimeMsg) +
    "</span></strong>";
  message += "<strong><span id='timeMarker'>" + localText["text.timeout.timeMarker.at"] + " " + time +
    "</span></strong></p>";

  var idleTimerInterval = setInterval(function () {
    var timestamp = Date.now();
    var millisecondsLeft = _showIdleMessageExpireTimestamp - timestamp;

    if(millisecondsLeft < 0) {
      millisecondsLeft = 0;
    }

    var idleTimeoutExceeded = true;
    if(millisecondsLeft > 0) {
      minutesLeft = Math.floor(millisecondsLeft / 60000);
      secondsLeft = Math.floor((millisecondsLeft % 60000) / 1000);

      if(minutesLeft > 0 || secondsLeft > 0) {
        idleTimeoutExceeded = false;
        if(minutesLeft == 1) {
          $("#timeMinuteMarker").html(singleMinuteTimeMsg);
        }
        if(secondsLeft == 1) {
          $("#timeSecondMarker").html(singleSecondTimeMsg);
        }
        if(minutesLeft > 0) {
          $("#timeMinuteMarker").show();
          $("#sessionTimeMinutesLeft").show();
          $("#sessionTimeMinutesLeft").html(minutesLeft);
        }
        else {
          $("#sessionTimeMinutesLeft").hide();
          $("#timeMinuteMarker").hide();
        }
        if(secondsLeft > 0) {
          $("#timeSecondMarker").show();
          $("#sessionTimeSecondsLeft").show();
          $("#sessionTimeSecondsLeft").html(secondsLeft);
        }
        else {
          $("#sessionTimeSecondsLeft").hide();
          $("#timeSecondMarker").hide();
        }
      }
    }

    if(idleTimeoutExceeded) {
      var optionsObject = {
        size: 'large',
        buttons: {
          main: {
            label: localText["text.timedout.confirm"],
            callback: function () {
              unsavedChanges = false;
              window.preventAbandonCartAlert = true;
              window.location.href = contextPath;
            }
          }
        },
        closeButton: false
      };
      var messageBasedOnContext = "";
      if(isInEnrollmentFlow()) {
        if(typeof hasEnrollmentCartEntries !== 'undefined') {
          if(hasEnrollmentCartEntries === 'true') {
            messageBasedOnContext = localText["text.timedout.body.enrolling.bag.expired"] + " ";
          }
        }
        messageBasedOnContext += localText["text.timedout.body.enrolling.signup.again"];
      }
      else {
        messageBasedOnContext = localText["text.timedout.body.logged.in"];
      }
      var message = localText["text.timedout.body"]
        .replace("{0}", getDuration())
        .replace("{1}", messageBasedOnContext);
      // Best effort logging of session timeout
      postTimeout().then(response => {
      });
      idleModal.modal('hide');
      idleModal = showGlobalBasicMessage(message, optionsObject);
      // Stop listening to user events onclick, onmousemove, onkeypress, ontouch, onscroll, etc.
      allowTimestampReset = false;
      // Stop all interval timers associated with idleness check
      clearInterval(idleTimerInterval);
      clearInterval(idleTimeCheckInterval);
    }
  }, 1000);

  var optionsObject = {
    size: 'large',
    title: localText["text.timeout.header"],
    buttons: {
      main: {
        label: localText["text.timeout.endSession"],
        callback: function () {
          unsavedChanges = false;
          window.location.href = contextPath + "/logout";
        }
      },
      danger: {
        label: localText["text.timeout.continueSession"],
        callback: function () {
          //Allow the user to continue with the same session without refreshing it.
          //OOTB the session will be automatically extended in the backend as well.
          clearInterval(idleTimerInterval);
          resetTimestamps("continue session");
        }
      }
    },
    closeButton: false
  };

  idleModal = showGlobalBasicMessage(message, optionsObject);
}

function formatTime(date) {
  var hours = date.getHours();
  var minutes = date.getMinutes();
  var seconds = date.getSeconds();
  var ampm = hours >= 12 ? 'pm' : 'am';
  hours = hours % 12;
  hours = hours ? hours : 12; // the hour '0' should be '12'
  minutes = minutes < 10 ? '0' + minutes : minutes; // if min less than 10 will appear as 04
  seconds = seconds < 10 ? '0' + seconds : seconds; // if sec less than 10 will appear as 04
  var strTime = hours + ':' + minutes + ':' + seconds + " " + ampm;
  return strTime;
}
